<template>
  <form-po
    ref="Form"
    :data="data"
    :dataID="data.id"
    :model="getModel"
    @updateModelItem="handlerUpdateModelItem"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
export default {
  name: 'SectionPOGeneral',
  mixins: [FormWrapperAutoSave],
  components: {
    'form-po': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './FormPO.vue')
  },
  created () {
    this.$bus.$onPromise('validate-all-sections', this.validate)
  },
  beforeDestroy () {
    this.$bus.$offPromise('validate-all-sections', this.validate)
  },
  props: {
    data: { type: Object }
  },
  computed: {
    isAvailableToSave () {
      return true
    }
  },
  methods: {
    getModel () {
      return {
        id: null,
        rfqid: null,
        entryDate: new Date(),
        po: '',
        baxpo: '',
        scoreID: null,
        employeeID: null,
        priorityID: null,
        remarks: ''
      }
    },
    validate () {
      return this.$refs.Form.validate()
    }
  }
}
</script>
